import PropTypes from 'prop-types';

import { THEME_ICON_NAME } from '@constants';

export const ThemeIconNames = PropTypes.oneOf(
  Object.values(THEME_ICON_NAME).map((iconName) => iconName)
);
